import plusIcon from "../../../../images/plus-solid.png";
import checkIcon from "../../../../images/check-solid.png";
import deleteIcon from "../../../../images/trash-solid.png";
import * as CommonUtilities from "../../../../common/utils/CommonUtils";

export default function ModifierComboParentButton(props) {
    // Returns Modifier Combo Button in <ModifierComboParentContainer /> inside Product Details Parent Page

    let buttonImageToDisplay;
    let productTextDisplay = props.modifierCategoryDetails.modLinkedToCombo.modName;
    let modifiersToDisplay, modifierDisplayContainer, priceIncMod = "";

    let removeComboButton = <></>

    // Calculate Price
    let modComboPriceInc = parseFloat(props.comboFormData.modComboPriceInc);
    let modGroupsPriceIncCalc = 0;
    props.comboFormData.modComboGroups.forEach((group) => {
        if (group.PriceInc === undefined) {
            modGroupsPriceIncCalc += parseFloat(0)
        } else {
            modGroupsPriceIncCalc += parseFloat(group.PriceInc)
        }
    })
    let totalPriceIncCalc = modComboPriceInc + modGroupsPriceIncCalc;
    let totalPriceIncDisplay = CommonUtilities.formatDisplayPrice(totalPriceIncCalc);

    if (!props.comboFormData[`ModComboModCatId${props.modifierCategoryDetails.modCategoryId}`]) {
        buttonImageToDisplay = <span className="bg-dark rounded-pill d-flex align-items-center justify-content-center" style={{width: "20px", height: "20px", minWidth: "20px"}}>
                                    <img src={plusIcon} alt="Add" title="Add" style={{width: "10px"}}></img>
                                </span>
        modifiersToDisplay = <></>
        modifierDisplayContainer = <></>
        priceIncMod = "";
        removeComboButton = <></>
    } else {
        buttonImageToDisplay = <span className="bg-success rounded-pill d-flex align-items-center justify-content-center" style={{width: "20px", height: "20px", minWidth: "20px"}}>
                                    <img src={checkIcon} alt="Selected" style={{width: "10px"}}></img>
                                </span>
        removeComboButton = <button type="button" className="btn btn-light border px-1" style={{width: "40px"}} title="Remove Combo" onClick={props.handleRemoveModifierComboFromProduct} data-modcombo-modcatid={props.modifierCategoryDetails.modCategoryId}>
                                <img src={deleteIcon} style={{width: "16px"}} alt="Remove icon"></img>
                            </button>
        let keyModListItem = -1;
        modifiersToDisplay = props.comboFormData.modComboGroups.map((mod) => {
            keyModListItem += 1;
            priceIncMod = CommonUtilities.formatDisplayPrice(mod.PriceInc);
            // Return modifiers selected in a list
            return <li key={keyModListItem}>{mod.ModifierName}<span className="ms-2 ps-1">{priceIncMod}</span></li>
        })
        modifierDisplayContainer = 
            <small className="text-muted">
                <ul className="mb-0">
                    {modifiersToDisplay}
                </ul>
            </small>
    }
    
    return (
        <div className="col-12 py-2 d-grid">
            <div className="input-group">
                    <button type="button" className={`btn btn-light border d-flex flex-row justify-content-start align-items-center py-3 col`} data-modcombo-modcatid={props.modifierCategoryDetails.modCategoryId} onClick={props.handleModifierComboSelect}>
                        {buttonImageToDisplay}
                        &emsp;<div className="d-flex flex-column align-items-start text-start text-break col-8">
                            <span>{productTextDisplay}</span>
                            {modifierDisplayContainer}
                        </div>
                        <div className="w-100 text-end">{totalPriceIncDisplay}</div>
                    </button>
                    {removeComboButton}
            </div>
        </div>
    )
}